import React from "react";

const CircleIcon28pxSvg = (props) => {
  return (
    <svg
      {...props}
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5292 28.9884C6.53079 29.0013 0.0362763 22.5278 0.0233377 14.5293C0.010399 6.53088 6.48393 0.0363661 14.4824 0.0234275C22.4808 0.0104888 28.9753 6.48402 28.9883 14.4825C29.0012 22.4809 22.5277 28.9754 14.5292 28.9884ZM14.4878 3.37599C8.34092 3.38593 3.36596 8.37702 3.3759 14.5239C3.38584 20.6708 8.37693 25.6457 14.5238 25.6358C20.6707 25.6259 25.6457 20.6348 25.6357 14.4879C25.6258 8.34101 20.6347 3.36605 14.4878 3.37599Z"
        fill="#19293C"
      />
    </svg>
  );
};

export default CircleIcon28pxSvg;
